import { onBeforeUnmount, ref, watch, type Ref } from 'vue';

const BELOW_FOLD_FALLBACK_MS = 3000;

/**
 * Блоки ниже статьи (листинг, соседние места, FAQ) не нужны для первого экрана, но их чанки (~100 КБ)
 * и картинки делили бы канал с главным фото и с ответом API. Показываем их, когда фото загрузилось,
 * а если оно не загрузилось, то по таймеру, чтобы контент не пропал.
 */
export const useBelowFold = (cardId: Ref<number | undefined>) => {
  const isBelowFoldVisible = ref(false);
  let timer: ReturnType<typeof setTimeout> | undefined;

  const showBelowFold = () => {
    clearTimeout(timer);
    isBelowFoldVisible.value = true;
  };

  watch(cardId, (id) => {
    if (id == null || isBelowFoldVisible.value) {
      return;
    }

    // якорь в URL (например, #sights) может вести в нижний блок, а скролл к нему ждёт узел всего 4 секунды
    if (window.location.hash) {
      showBelowFold();
      return;
    }

    timer = setTimeout(showBelowFold, BELOW_FOLD_FALLBACK_MS);
  });

  onBeforeUnmount(() => {
    clearTimeout(timer);
  });

  return { isBelowFoldVisible, showBelowFold };
};
